export const GET_TOUR_PENDING = 'getTourAppPending';
export const GET_TOUR_FULFILLED = 'getTourAppFulfilled';
export const GET_TOUR_REJECTED = 'getTourAppRejected';

export const GET_BACKGROUND_PHOTO_PENDING = 'getBackgroundImageAppPending';
export const GET_BACKGROUND_PHOTO_FULFILLED = 'getBackgroundImageAppFulfilled';
export const GET_BACKGROUND_PHOTO_REJECTED = 'getBackgroundImageAppRejected';

export const SET_URL_PARAMS = 'setUrlParamsApp';
export const SET_CONTENT_BLUR = 'setContentBlurApp';

export const SAVE_POSITION = 'savePositionApp';
export const CLEAR_POSITION = 'clearPositionApp';
export const TOGGLE_FULLSCREEN = 'toggleFulscreenApp';

export const PROD_URL = 'vifp.com';
export const DEV_URL = 'dev.vifp.com';
export const LOCAL_URL = 'vifp.local';

export const POST_MESSAGE_EVENT = 'postMessageEvent'
